import React from 'react';
import '../styles/process.page.scss';
import { Container, Col } from 'react-bootstrap';
import PageTitle from '../components/PageTitle';

export default function FAQ({ l }) {
    return (
        <Container>
            <PageTitle title={l.pageTitle} />
            <div className="mt-n3">
                {l.faqItems.map((faq, i) => renderFaq(faq, i))}
            </div>
        </Container>
    )
}

function renderFaq(faq, i) {
    return (
        <Col xs={12} lg={10} className="mt-1 mt-md-3" key={`faq-${i}`}>
            <div>
                <p className="mb-1 h4 font-weight-bold" dangerouslySetInnerHTML={{__html: faq.question}}></p>
            </div>
            <div>
                <p className="" dangerouslySetInnerHTML={{__html: faq.answer}}></p>
            </div>
        </Col>
    )
}